import { AxiosInstance } from 'axios';
import ShiftRepositoryInterface, {
  ApiCreateShiftInterface,
  BulkUserShiftInterface, CreateShiftSchedule,
  ShiftInterface,
} from '@/services/Calendar/Shifts/Interfaces';

export default class ShiftRepository implements ShiftRepositoryInterface {
  private apiPrefix = '/calendar/shifts';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllShifts(): Promise<ShiftInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async getUserShifts(userId: string, date: Date): Promise<ShiftInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}/user/${userId}?date=${date.toISOString().substr(0, 10)}`);

    return res.data;
  }

  public async getShiftsByUsersIds(ids: string[], date: Date): Promise<BulkUserShiftInterface[]> {
    const res = await this.axios.post(`${this.apiPrefix}/bulk`, { ids, date: date.toISOString() });

    return res.data;
  }

  public async createShift(data: ApiCreateShiftInterface): Promise<boolean> {
    try {
      const res = await this.axios.post(this.apiPrefix, data);

      return res.status === 201;
    } catch (e) {
      if (e.response.data.message) {
        throw new Error(e.response.data.message);
      }

      return false
    }
  }

  public async approveShifts(startDate: Date, endDate: Date, isApproved: boolean, departmentId: string): Promise<void> {
    await this.axios.post(`${this.apiPrefix}/approve`, { startDate, endDate, isApproved, departmentId });
  }

  public async deleteShift(userId: string, date: Date, applySameShiftsToTeam: boolean): Promise<void> {
    await this.axios.delete(this.apiPrefix, { data: { userId, date, applySameShiftsToTeam } });
  }

 public async createShiftSchedule(data: CreateShiftSchedule): Promise<void> {
    await this.axios.post(`${this.apiPrefix}/schedule`, data);
 }

  public async deleteShiftSchedule( userId: string, startDate: Date, endDate: Date): Promise<void> {
    await this.axios.delete(`${this.apiPrefix}/schedule`, { data: { userId, startDate, endDate } });
  }
}
